import React from "react";
import styled from "styled-components";

const HorizontalLine = ()=>{

    return(
        <HR />
    )

}

const HR = styled.div`
    margin: 20px 0;
    width: 90%;
    border-top: 1px solid lightgray;
`;

export default HorizontalLine